<template>
  <section>
    <ArchivingModal />
    <DuplicateSessionModal
      v-if="$route.meta.subcategory === 'sessions'"
      :data="duplicateModalState"
      @close-modal="closeDuplicateModal"
    />
    <DuplicateModal v-else />
    <DetailModal
      v-if="$route.meta.subcategory === 'sessions'"
      :data="detailModalState"
      @close-modal="closeDetailModal"
    />
    <EventViewModal v-if="$route.meta.subcategory === 'events'" />
    <div v-show="showToggle" class="flex mt-5 flex-wrap justify-end mr-5">
      <div
        class="inline-flex items-center rounded-full p-1 bg-gray-300 h-10 mr-2"
      >
        <label for="my-items" data-testid="my-items-toggle">
          <input
            type="radio"
            id="my-items"
            name="toggle"
            value="my-items"
            v-model="toggleState"
            checked
            class="hidden peer"
            @change="handleToggleChange"
          />
          <span
            for="my-items"
            class="px-4 py-1 rounded-full cursor-pointer bg-gray-300 text-black peer-checked:bg-blue-700 peer-checked:text-white"
          >
            My Items
          </span>
        </label>

        <label for="shared-items" data-testid="shared-items-toggle">
          <input
            type="radio"
            id="shared-items"
            name="toggle"
            value="shared-items"
            v-model="toggleState"
            class="hidden peer"
            @change="handleToggleChange"
          />
          <span
            for="shared-items"
            class="px-4 py-1 rounded-full cursor-pointer bg-gray-300 text-black peer-checked:bg-blue-700 peer-checked:text-white"
          >
            Shared Items
          </span>
        </label>

        <label
          v-if="showHideUnhide"
          for="hidden"
          data-testid="hidden-items-toggle"
        >
          <input
            type="radio"
            id="hidden"
            name="toggle"
            value="hidden"
            v-model="toggleState"
            class="hidden peer"
            @change="handleToggleChange"
          />
          <span
            class="px-4 py-1 rounded-full cursor-pointer bg-gray-300 text-black peer-checked:bg-blue-700 peer-checked:text-white"
          >
            Hidden
          </span>
        </label>
      </div>
    </div>
    <div
      class="flex mt-4 mx-auto justify-between px-3 max-w-screen-2xl flex-wrap"
    >
      <div
        v-if="toggleState === 'shared-items' && showHideUnhide"
        class="flex items-end justify-around md:ml-7"
      >
        <button
          :class="`${secondaryColorClass}`"
          class="mr-7 text-center uppercase"
          :disabled="selectedItems.length < 1"
          @click="handleBlock"
          data-testid="block-button"
        >
          HIDE
        </button>
      </div>
      <div
        v-else-if="toggleState === 'hidden' && showHideUnhide"
        class="flex items-end justify-around md:ml-7"
      >
        <button
          :class="`${secondaryColorClass}`"
          class="mr-7 text-center uppercase"
          :disabled="selectedItems.length < 1"
          @click="handleUnblock"
          data-testid="unblock-button"
        >
          UNHIDE
        </button>
      </div>
      <div v-else class="flex items-end justify-around md:ml-7">
        <!-- BULK EDIT is not doing anything as of now and should be hidden accross all libraries -->
        <!-- <button
          v-if="showBulkActions"
          :class="`${secondaryColorClass}`"
          class="mr-7 text-center uppercase"
          disabled
        >
          BULK EDIT
        </button> -->
        <button
          v-if="
            hasWritePermission &&
            showArchive &&
            toggleState !== 'hidden' &&
            toggleState !== 'shared-items'
          "
          :class="`${secondaryColorClass}`"
          class="mr-7 text-center uppercase"
          :disabled="selectedItems.length < 1"
          @click="openArchive"
        >
          ARCHIVE
        </button>
      <button
          v-if="showHideButtonForMyItems"
          :class="`${secondaryColorClass}`"
          class="text-center uppercase"
          :disabled="selectedItems.length < 1"
          @click="handleBlock"
          data-testid="block-my-items-button"
        >
          HIDE
        </button>
      </div>
      <div class="flex flex-wrap">
        <SearchBar
          class="align-end flex mr-3 mt-3 min-w-[300px] md:w-[400px] searchbar xs:mt-0 sm:mr-7"
          :input-from-parent="q"
          @handleSearch="handleSearch"
          @handleCustomFilter="openAdvancedFilters = true"
        >
          <template
            v-if="
              $route.meta?.subcategory === 'sessions' ||
              $route.meta?.subcategory === 'events' ||
              $route.meta?.subcategory === 'programs'
            "
            #advancedFilters
          >
            <SessionAdvancedFiltersModal
              v-show="$route.meta?.subcategory === 'sessions'"
              @update-filters="updateSessionAdvancedFilters"
            />

            <EventAdvancedFiltersModal
              v-show="$route.meta?.subcategory === 'events'"
              @update-filters="updateEventAdvancedFilters"
            />
            <ProgramsAdvancedFilterModal
              v-show="$route.meta?.subcategory === 'programs'"
              :is-shared-items-tab="this.toggleState === TOGGLE_STATE.SHARED_ITEMS"
              @update-filters="updateProgramsAdvancedFilters"
            />
          </template>
        </SearchBar>
        <HousingModals
          v-if="subcategory === 'Housing'"
          :is-default-open="defaultOpen && hasWritePermission"
          :is-disabled="!(hasWritePermission || hasPublishPermission)"
        />
        <ProgramSessionCreateModal v-else-if="isProgramSessions" />
        <BaseButton
          v-else-if="createRouteName"
          type="button"
          variant="primary"
          variant-type="block"
          outlined
          :on-click="redirectToCreatePage"
          :disabled="!(hasWritePermission || hasPublishPermission)"
          class="mt-3 xs:mt-0"
        >
          New
        </BaseButton>
        <component
          :is="currentAdvancedFilter"
          :title="`${subcategory} Filter`"
          :is-modal-open="openAdvancedFilters"
          @closeModal="openAdvancedFilters = false"
        />
      </div>
    </div>
    <div class="flex justify-center">
      <BaseTable
        v-if="!getLoading && !getListingError && !toggleAction"
        class="max-w-screen-2xl"
        :header-visible="false"
        :active-filter="getActiveFilter"
        :headers="visibleHeaders"
        :rows="getTableItems"
        :actions-routes="getTableItemActionsRoutes"
        :show-checkbox="hasWritePermission"
        @open-duplicate-modal="openDuplicateModal"
        @open-detail-modal="openDetailModal"
      />
      <Spinner
        v-else-if="(getLoading && !getListingError) || toggleAction"
        class="relative h-65vh bg-blue-100"
      />
      <ErrorPage v-else-if="getListingError" :message="getListingError" />
    </div>
    <footer>
      <Pagination
        v-if="showPagination"
        class="mb-14"
        :page="page"
        :total-of-records="getActiveFilter.count"
        :records-per-page="limit"
        @changePage="changePage"
      />
    </footer>
  </section>
</template>

<script>
import { cloneDeep } from "lodash";
import { useToast } from "vue-toast-notification";
import { mapActions, mapGetters, mapState } from "vuex";
import ErrorPage from "@/components/errorPage.vue";
import Spinner from "@/components/helpers/Spinner.vue";
import DetailModal from "@/components/modals/DetailModal";
import HousingModals from "@/components/modals/housing/HousingModals.vue";
import { statusesIds } from "@/components/program-manager/create-edit/utils.js";
import EventAdvancedFiltersModal from "@/components/program-manager/events/components/AdvancedFilters";
import { EVENTS_INCLUDE_FIELDS } from "@/components/program-manager/events/constants.js";
import { setIncludedFields } from "@/components/program-manager/events/utils.js";
import ClassesFilterModal from "@/components/program-manager/housing/components/AdvancedFilters/Classes";
import HousingFilterModal from "@/components/program-manager/housing/components/AdvancedFilters/Housing";
import InternshipsFilterModal from "@/components/program-manager/housing/components/AdvancedFilters/Internships";
import ProgramsAdvancedFilterModal from "@/components/program-manager/programs/components/AdvancedFiltersModal";
import SessionAdvancedFiltersModal from "@/components/program-manager/sessions/components/AdvancedFiltersModal";
import ProgramSessionCreateModal from "@/components/program-manager/sessions/components/ProgramSessionCreateModal";
import {
  PROGRAM_PAGE_INCLUDE_FIELDS,
  SESSION_INCLUDE_FIELDS,
  sessionStatus,
} from "@/components/program-manager/sessions/constants.js";
import BreadCrumb from "@/components/shared/BreadCrumb.vue";
import BaseButton from "@/components/shared/Button/BaseButton.vue";
import Pagination from "@/components/shared/Pagination.vue";
import SearchBar from "@/components/shared/SearchBar.vue";
import BaseTable from "@/components/shared/Table/BaseTable.vue";
import { useVisibleHeaders } from "@/composables/visibleHeaders";
import { ACTIVE_STATUS, LIBRARY_IDS, PERMISSIONS, viewMorePages } from "@/constants";
import { eventBus } from "@/eventBus.js";
import entityVisibilityService from "@/services/entityVisibility";
import ArchivingModal from "../../modals/ArchivingModal";
import DuplicateModal from "../../modals/DuplicateModal.vue";
import DuplicateSessionModal from "../../modals/duplicate/ProgramSession.vue";
import EventViewModal from "../../modals/events/EventsView.vue";
import { CurrentViewMorePage, LIBRARIES_USING_IS_SHARED_WITH, TOGGLE_STATE } from "./constants";
import { internshipFilter } from "./filters";

const viewMoreFilters = {
  internships: internshipFilter,
};

export default {
  name: "ProgramManagerViewMore",
  components: {
    ArchivingModal,
    DuplicateModal,
    DuplicateSessionModal,
    EventViewModal,
    DetailModal,
    BaseButton,
    BaseTable,
    BreadCrumb,
    ClassesFilterModal,
    HousingFilterModal,
    HousingModals,
    InternshipsFilterModal,
    EventAdvancedFiltersModal,
    Pagination,
    ProgramsAdvancedFilterModal,
    SearchBar,
    Spinner,
    ErrorPage,
    ProgramSessionCreateModal,
    SessionAdvancedFiltersModal,
  },
  beforeRouteEnter(to, from, next) {
    to.meta.breadcrumb[1] = {
      title: to.meta.subcategory.replace(/^\w/, (c) => c.toUpperCase()),
      parent: to.name,
      active: true,
    };
    next((vm) => {
      // try to load filters from sessionStorage
      const filters = sessionStorage.getItem("filters");
      if (filters) {
        vm.setAdvancedFilters(JSON.parse(filters));
      }
    });
  },
  props: {
    defaultOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { visibleHeaders, defaultHeaders, setVisibleHeaders, updateHeaders, setPersistedHeaders } =
      useVisibleHeaders(9);
    const toast = useToast();
    return {
      visibleHeaders,
      defaultHeaders,
      setVisibleHeaders,
      updateHeaders,
      setPersistedHeaders,
      toast,
    };
  },
  data() {
    return {
      recentlyHiddenColumns: [],
      currentAdvancedFilter: "HousingFilterModal",
      currentViewmorePage: this.$route?.meta?.subcategory ?? "",
      openAdvancedFilters: false,
      page: 1,
      searchtext: "",
      selectedItems: [],
      subcategory: undefined,
      duplicateModalState: {
        state: false,
        id: undefined,
      },
      detailModalState: {
        state: false,
        id: undefined,
      },
      sessionCurrentFilters: {},
      eventCurrentFilters: {},
      programPageCurrentFilters: {},
      toggleState: "my-items",
      toggleAction: false,
      TOGGLE_STATE,
    };
  },
  computed: {
    ...mapGetters("programManager", [
      "getAdvancedFilters",
      "getActiveFilter",
      "getTableItems",
      "getTableHeaders",
      "getCards",
      "getTableItemActionsRoutes",
      "getCurrentEntity",
      "getLoading",
      "getListingError",
      "getEntityFilters",
      "getSelectedEntityView",
    ]),
    ...mapGetters({
      permissions: "getPermissions",
      userEntities: "getEntityIds",
    }),
    ...mapState(["featureFlags"]),
    pageFetcheDataBasedOnColumns() {
      return ["sessions", "events"].includes(this.currentViewmorePage);
    },
    getSubcategoryCapitalized() {
      return this.$route.meta.subcategory.replace(/^\w/, (c) => c.toUpperCase());
    },
    showPagination() {
      return this.getActiveFilter.count > this.limit;
    },
    hasWritePermission() {
      return this.permissions.includes(PERMISSIONS.ITEMS_WRITE);
    },
    hasPublishPermission() {
      return this.permissions.includes(PERMISSIONS.ITEMS_PUB);
    },
    showHideUnhide() {
      const subcategoriesToHide = ["internships", "classes", "housing", "events"];
      return !subcategoriesToHide.includes(this.$route.meta.subcategory);
    },
    showHideButtonForMyItems() {
      return this.toggleState === "my-items" && this.$route.meta.subcategory === "programs";
    },
    showArchive() {
      const subcategoriesToHide = ["classes"];
      return !subcategoriesToHide.includes(this.$route.meta.subcategory);
    },
    createRouteName() {
      return this.getTableItemActionsRoutes.create ?? "";
    },
    isProgramSessions() {
      return this.$route?.meta?.subcategory === "sessions";
    },
    limit() {
      return this.currentViewmorePage !== "programs" && this.currentViewmorePage !== "sessions" ? 25 : 10; // https://apiabroad.atlassian.net/browse/RAG-634 bugfix
    },
    isShowToggle() {
      return viewMorePages.includes(this.currentViewmorePage);
    },
    showToggle() {
      return this.isShowToggle && !this.getLoading;
    },
  },
  beforeUnmount() {
    // Prevent event bus from executing callbacks multiple times
    eventBus.$off("updateSelectedItems");
    eventBus.$off("updateHeaders");
  },
  created() {
    const currentLibraryFilters = this.getActiveFilter?.title?.toLowerCase();
    if (currentLibraryFilters !== this.currentViewmorePage) {
      this.$store.commit("programManager/setAdvancedFilters", {});
    }

    this.setPersistedHeaders([]);

    eventBus.$on("updateSelectedItems", (data) => {
      this.updateSelectedItems(data);
    });
    eventBus.$on("updateHeaders", (selectedHeaders) => {
      const needsToFetch = this.columnRequiresNewFetch(selectedHeaders);
      this.setRecentlyHiddenColumns(this.visibleHeaders, selectedHeaders);
      this.setPersistedHeaders(selectedHeaders);
      this.updateHeaders(selectedHeaders);
      if (this.pageFetcheDataBasedOnColumns && needsToFetch) {
        this.requestTableData();
      }
    });

    this.setVisibleHeaders(this.defaultHeaders);
    this.subcategory = this.getSubcategoryCapitalized;
    this.currentAdvancedFilter = `${this.subcategory}FilterModal`;
    const { page, q } = this.$route.query;
    this.q = q || "";
    this.page = Number(page) || 1;
    if (this.getCurrentEntity !== this.$route.meta.subcategory || this.getTableItems.length <= this.limit) {
      this.updateHeaders([]);
      this.requestTableData();
    }

    this.eventCategories();
    this.eventSubCategories();
    this.fetchTestimonialsData();
  },
  watch: {
    getSelectedEntityView(newEntity, oldEntity) {
      if (newEntity && newEntity.id !== oldEntity?.id) {
        this.resetToggleState();
      }
    },
  },
  methods: {
    ...mapActions({
      classes: "programManager/fetchClassesData",
      housing: "programManager/fetchHousingData",
      programs: "programManager/fetchProgramsData",
      programsPage: "programManager/fetchProgramPagesData",
      sessions: "programManager/fetchProgramSessionsData",
      internships: "programManager/fetchInternshipsData",
      setAllCounts: "programManager/setAllCounts",
      events: "programManager/fetchEventsData",
      clearProgramManagerData: "programManager/clearProgramManagerData",
      eventCategories: "events/fetchCategories",
      eventSubCategories: "events/fetchSubCategories",
      fetchTestimonialsData: "testimonialManager/fetchTestimonialsData",
    }),
    columnRequiresNewFetch(currentlySelected = []) {
      let requireNewFetch = false;
      if (this.pageFetcheDataBasedOnColumns) {
        for (let i = 0; i < currentlySelected.length; i++) {
          if (
            !this.recentlyHiddenColumns.includes(currentlySelected[i]) &&
            !this.visibleHeaders.includes(currentlySelected[i])
          ) {
            requireNewFetch = true;
            break;
          }
        }
      }
      return requireNewFetch;
    },
    setRecentlyHiddenColumns(previouslyVisible = [], currentlySelected = []) {
      if (this.pageFetcheDataBasedOnColumns) {
        // Add columns that were removed
        previouslyVisible.forEach((previousColumn) => {
          if (!currentlySelected.includes(previousColumn)) {
            this.recentlyHiddenColumns.push(previousColumn);
          }
        });

        // Remove hidden columns if they were added back
        this.recentlyHiddenColumns = this.recentlyHiddenColumns.filter((hiddenCol) => {
          return !currentlySelected.includes(hiddenCol);
        });
      }
    },
    setDefaultEventFields() {
      if (Array.isArray(this.visibleHeaders) && this.visibleHeaders.length > 1) {
        return false;
      }
      return true;
    },
    getBaseFilters() {
      const entityFilter = this.getEntityFilters[this.currentViewmorePage] || {};
      let payload = { extraParams: {} };

      // As we roll out the 'is_shared_with' filter for other libraries add them to this list
      const shouldSendIsSharedWithFilter = LIBRARIES_USING_IS_SHARED_WITH.includes(this.currentViewmorePage);

      let allAvailableKey;
      let statusKey;
      let statusValue;

      switch (this.currentViewmorePage) {
        case CurrentViewMorePage.Sessions:
          allAvailableKey = "all_available_sessions";
          statusKey = "status";
          statusValue = [sessionStatus.openEnrollment, sessionStatus.inSession];
          break;
        case CurrentViewMorePage.Programs:
          allAvailableKey = "all_available_program_pages";
          statusKey = "status_id";
          statusValue = statusesIds.ACTIVE;
          break;
        case CurrentViewMorePage.Internships:
          allAvailableKey = "all_available_internships";
          statusKey = "status";
          statusValue = ACTIVE_STATUS;
          break;
        case CurrentViewMorePage.Housing:
          allAvailableKey = "all_available_housing";
          statusKey = "status";
          statusValue = ACTIVE_STATUS;
          break;
        case CurrentViewMorePage.Events:
          statusKey = "status";
          statusValue = ACTIVE_STATUS;
          break;
        default:
          break;
      }

      switch (this.toggleState) {
        case "my-items":
          payload = {
            extraParams: {
              owner_entity_id: this.getSelectedEntityView?.id,
            },
          };
          break;
        case "shared-items": {
          const sharedParams = {
            ...entityFilter,
            is_approved_for_subdomain: true,
            only_marketplace: true,
            [statusKey]: statusValue,
          };
          if (shouldSendIsSharedWithFilter) {
            sharedParams.is_shared_with = true;
          }
          payload = {
            extraParams: sharedParams,
          };
          break;
        }
        case "hidden": {
          const sharedParams = {
            ...entityFilter,
            is_approved_for_subdomain: "false",
            [allAvailableKey]: true,
          };
          if (shouldSendIsSharedWithFilter) {
            sharedParams.is_shared_with = true;
          }
          payload = {
            extraParams: sharedParams,
          };
          break;
        }
      }

      return payload;
    },
    requestTableData() {
      // before calling the API endpoint, format the filters
      this.recentlyHiddenColumns = []; // On data fetch hidden columns aren't needed
      let formattedFilters = {};
      const payload = this.getBaseFilters();

      switch (this.currentViewmorePage) {
        case CurrentViewMorePage.Sessions:
          formattedFilters = this.sessionCurrentFilters;
          payload.extraParams = {
            ...payload.extraParams,
            ...formattedFilters,
            include: SESSION_INCLUDE_FIELDS,
          };
          break;
        case CurrentViewMorePage.Programs:
          formattedFilters = cloneDeep(this.programPageCurrentFilters);
          if (this.toggleState === TOGGLE_STATE.SHARED_ITEMS) {
            // Remove conflicting filters while on Shared Items tab
            formattedFilters.status_ids = [];
            formattedFilters.marketplace = undefined;
          }
          payload.extraParams = {
            ...payload.extraParams,
            ...formattedFilters,
            include: PROGRAM_PAGE_INCLUDE_FIELDS,
          };
          break;
        case CurrentViewMorePage.Events:
          formattedFilters = this.eventCurrentFilters;
          payload.extraParams = {
            ...payload.extraParams,
            ...formattedFilters,
            include: this.setDefaultEventFields()
              ? EVENTS_INCLUDE_FIELDS
              : [...setIncludedFields(this.visibleHeaders), ...EVENTS_INCLUDE_FIELDS],
          };
          break;
        case CurrentViewMorePage.Internships:
          formattedFilters = viewMoreFilters[this.currentViewmorePage](this.getAdvancedFilters);
          payload.extraParams = {
            ...payload.extraParams,
            ...formattedFilters,
          };
          break;
        case CurrentViewMorePage.Housing:
          payload.extraParams = {
            ...payload.extraParams,
            ...this.getAdvancedFilters,
          };
          break;
      }

      if (this[this.currentViewmorePage]) {
        try {
          this[this.currentViewmorePage]({
            limit: this.limit,
            page: this.page,
            q: this.searchtext,
            ...payload,
          });
        } catch (error) {
          if (error.code === 413) {
            toast.open({
              message: "Error: entity is too large",
              type: "error",
              position: "bottom",
              duration: 5000,
            });
          }
        }
      } else {
        toast.open({
          message: `Couldn't find this library`,
          type: "error",
          position: "bottom",
          duration: 5000,
        });
      }
    },
    handleSearch(q) {
      this.searchtext = q;
      setTimeout(() => {
        if (q === this.searchtext) {
          this.$router.push({
            query: { page: 1, ...(this.searchtext && { q: this.searchtext }) },
          });
          this.requestTableData();
        }
      }, 1000);
    },
    changePage(page) {
      this.page = page;
      setTimeout(() => {
        if (page === this.page) {
          this.$router.push({
            query: { page, ...(this.searchtext && { q: this.searchtext }) },
          });
          this.requestTableData();
        }
      }, 1000);
    },
    updateSelectedItems(items) {
      this.selectedItems = items;
    },
    openArchive() {
      this.$store.dispatch("programManager/setArchivingModalStateOpen", {
        selectedItems: this.selectedItems,
      });
    },
    redirectToCreatePage() {
      this.$router.push({ name: this.createRouteName });
    },
    openDuplicateModal({ id }) {
      this.duplicateModalState = { id, state: true };
    },
    closeDuplicateModal() {
      this.duplicateModalState = { id: undefined, state: false };
    },
    openDetailModal({ id }) {
      this.detailModalState = { id, state: true };
    },
    closeDetailModal() {
      this.detailModalState = { id: undefined, state: false };
    },
    updateSessionAdvancedFilters(filters) {
      const baseFilters = this.getBaseFilters();
      const mergedFilters = {
        ...baseFilters.extraParams,
        ...filters,
        include: SESSION_INCLUDE_FIELDS,
      };

      this.sessions({
        limit: this.limit,
        page: this.page,
        q: this.searchtext,
        extraParams: mergedFilters,
      });
      this.sessionCurrentFilters = filters;
    },
    updateEventAdvancedFilters(filters) {
      const baseFilters = this.getBaseFilters();
      const mergedFilters = {
        ...baseFilters.extraParams,
        ...filters,
        include: this.setDefaultEventFields()
          ? EVENTS_INCLUDE_FIELDS
          : [...setIncludedFields(this.visibleHeaders), ...EVENTS_INCLUDE_FIELDS],
      };

      this.events({
        limit: this.limit,
        page: this.page,
        q: this.searchtext,
        extraParams: mergedFilters,
      });
      this.eventCurrentFilters = filters;
    },
    updateProgramsAdvancedFilters(filters) {
      const baseFilters = this.getBaseFilters();
      const mergedFilters = {
        ...baseFilters.extraParams,
        ...filters,
        include: PROGRAM_PAGE_INCLUDE_FIELDS,
      };
      if (this.toggleState === TOGGLE_STATE.SHARED_ITEMS) {
        // Remove conflicting filters while on Shared Items tab
        mergedFilters.status_ids = [];
        mergedFilters.marketplace = undefined;
      }
      this.programs({
        limit: this.limit,
        page: this.page,
        q: this.searchtext,
        extraParams: mergedFilters,
      });
      this.programPageCurrentFilters = filters;
    },
    formatLibraryPayload(libraryName, filters) {
      switch (libraryName) {
        case "session":
          return { extraParams: filters };
        case "internship":
          return filters;
      }
    },
    handleToggleChange(event) {
      this.toggleState = event.target.value;
      this.resetPageParam();
      this.requestTableData();
    },
    async handleBlock() {
      this.toggleAction = true;
      try {
        const entity_id = this.getSelectedEntityView?.id;
        const data = this.selectedItems.map((item) => ({
          entity_id: entity_id,
          product_id: item,
          library_id: LIBRARY_IDS[this.currentViewmorePage],
        }));
        await entityVisibilityService.optOut(data);
        this.requestTableData();
        this.toast.open({
          message: "Selected items hidden successfully.",
          type: "success",
          position: "bottom",
          duration: 5000,
        });
      } catch (error) {
        this.toast.open({
          message: "Failed to hide selected items.",
          type: "error",
          position: "bottom",
          duration: 5000,
        });
      } finally {
        this.toggleAction = false;
      }
    },
    async handleUnblock() {
      this.toggleAction = true;
      try {
        const entity_id = this.getSelectedEntityView?.id;
        const product_ids = this.selectedItems.map((item) => item);
        await entityVisibilityService.optIn(entity_id, product_ids);
        this.requestTableData();
        this.toast.open({
          message: "Selected items unhidden successfully.",
          type: "success",
          position: "bottom",
          duration: 5000,
        });
      } catch (error) {
        this.toast.open({
          message: "Failed to unhide selected items.",
          type: "error",
          position: "bottom",
          duration: 5000,
        });
      } finally {
        this.toggleAction = false;
      }
    },
    resetToggleState() {
      this.toggleState = "my-items";
      this.resetPageParam();
      this.requestTableData();
    },
    resetPageParam() {
      const query = { ...this.$route.query };

      if ("page" in query) {
        this.page = 1;
        this.$router.push({ query: { page: this.page } });
      }
    },
  },
};
</script>
